module.exports = __webpack_public_path__ + "img/CertificateOfHonor02.778b2911.png";